module.exports = __webpack_public_path__ + "static/media/40.ede2db9f.svg";